// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a-join-telegram__text[data-v-c3dee6f0]{font-size:15px;line-height:20px;margin-left:5px;color:#fff}.a-join-telegram__text_yellow[data-v-c3dee6f0]{color:#ffde00}", ""]);
// Exports
module.exports = exports;
